import React, { useEffect } from 'react';
import { useTierListStore } from './store/tierListStore';
import { useThemeStore } from './store/themeStore';
import { Home } from './components/Home';
import { TierList } from './components/TierList';
import { ThemeToggle } from './components/ThemeToggle';

function App() {
  const { state, dispatch } = useTierListStore();
  const { theme } = useThemeStore();

  // Handle theme changes
  useEffect(() => {
    const root = window.document.documentElement;
    const isDark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [theme]);

  // Handle hash changes
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      if (hash) {
        const tierList = state.tierLists.find(list => list.id === hash);
        if (tierList) {
          dispatch({ type: 'SELECT_TIER_LIST', payload: { id: hash } });
        }
      } else {
        dispatch({ type: 'SELECT_TIER_LIST', payload: { id: null } });
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [state.tierLists, dispatch]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors">
      <header className="bg-white dark:bg-gray-800 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            <a
              href="#"
              className="text-2xl font-bold text-gray-900 dark:text-white hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
            >
              Tier List Maker
            </a>
            <ThemeToggle />
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        {state.currentTierListId ? (
          <TierList id={state.currentTierListId} />
        ) : (
          <Home />
        )}
      </main>
    </div>
  );
}

export default App